import styles from './TranslationModeBar.module.scss';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { changeTranslationMode } from '../../redux/actions/global';

const TranslationModeBar = () => {
    const dispatch = useDispatch();
    const translationMode = useSelector(state => state.global.translationMode);

    const turnOffTranslationMode = () => {
        dispatch(changeTranslationMode(false));
    };

    return (
        translationMode && (
            <div className={styles.translationModeBar}>
                <span>Translation Mode</span>
                <Button icon={<CloseOutlined />} onClick={turnOffTranslationMode} />
            </div>
        )
    );
};

export default TranslationModeBar;
